var HeaderFocusBehaviour;
(function (HeaderFocusBehaviour) {
    HeaderFocusBehaviour[HeaderFocusBehaviour["EVERY_RENDER"] = 0] = "EVERY_RENDER";
    HeaderFocusBehaviour[HeaderFocusBehaviour["FIRST_RENDER_ONLY"] = 1] = "FIRST_RENDER_ONLY";
})(HeaderFocusBehaviour || (HeaderFocusBehaviour = {}));
export default HeaderFocusBehaviour;
//# sourceMappingURL=HeaderFocusBehaviour.js.map